
    import { mapState, mapActions } from 'vuex';
    import has from 'lodash/has';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faPenNib as farPenNib,
    } from '@fortawesome/pro-regular-svg-icons/faPenNib';
    import {
        faChevronRight as fasChevronRight,
    } from '@fortawesome/pro-solid-svg-icons/faChevronRight';

    import datalayer from '@/utils/datalayer';
    import { jobData } from '@/utils/jobData';

    export default {
        components: {
            FontAwesomeIcon,
        },

        props: {
            sitePosition: {
                type: String,
                default: '',
            },

            ctaLabel: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                icons: {
                    fasChevronRight,
                    farPenNib,
                },
            };
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
                $_search: state => state.search,
                $_scoringData: state => state.me.scoringData,
            }),
        },

        methods: {
            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),

            visibilityChanged(isVisible) {
                if (isVisible) {
                    this.promptEvent('ad_impression', 'topresume_ad_unit');
                }
            },

            promptEvent(eventName, eventCode) {
                let data = {};

                if (this.$_job.id) {
                    data = {
                        event: eventName,
                        code: eventCode,
                        site_position: this.sitePosition,
                        page_referral_element: this.sitePosition,
                        cta: this.ctaLabel,
                        ...jobData(this.$_job),
                        seeker_match_score: this.$_job.seeker_match_score,
                        seeker_data: this.$_scoringData,
                    };
                    if (has(this.$_search, 'searchPayload.search_results.jobs')) {
                        data.job_uuids = this.$_search.searchPayload.search_results.jobs.map(o => o.uuid);
                    }
                    if (has(this.$_search, 'searchPayload.search_filters')) {
                        data.search_filters = this.$_search.searchPayload.search_filters;
                    }
                } else {
                    data = {
                        event: eventName,
                        code: eventCode,
                        site_position: this.sitePosition,
                        page_referral_element: this.sitePosition,
                        cta: this.ctaLabel,
                        seeker_data: this.$_scoringData,
                    };
                }
                datalayer(data);
                this.$_pushEvent(data);
            },
        },
    };
